import clsx from 'clsx';

import { Button } from 'components/curo-components/common/Button';

import styles from './GiveUsACall.module.scss';

const GiveUsACall = () => {
  const callByPhone = () => {
    window.open(`tel:${18554203434}`, '_self');
  };

  return (
    <div className={styles.mainWrapper}>
      <h5 className={styles.subtitle}>Give us a call</h5>

      <div className={styles.scheduleWrapper}>
        <div className={styles.scheduleText}>M–F: 8:30 AM–8:00 PM EST</div>
        <div className={styles.scheduleText}>Sa: 9:00 AM–6:00 PM EST</div>
        <a
          href={`tel:${18554203434}`}
          className={clsx(styles.scheduleText, styles.linkText)}
          target="_self"
        >
          (855) 420-3434
        </a>
      </div>

      <Button onClick={callByPhone} kind="primary" size="form">
        Call 1-855-420-3434
      </Button>
    </div>
  );
};

export default GiveUsACall;
